<template>
  <g-master name="greportcol"
            :endpoint="GColMaster.endpoint"
            :tableSetup="GColMaster.tableSetup"
            :modalFieldsSetup="GColMaster.modalFieldsSetup"
            :parentData="jbParentData"
  >
    <template slot="masterModal" slot-scope="{record}">
      <a-col v-bind="colOptions">
        <a-form-item v-bind="fiOptions" label="Columna: " :has-feedback="false">
          <a-input
            v-decorator="['column', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
        </a-form-item>
      </a-col>

      <a-col v-bind="colOptions">
        <a-form-item v-bind="fiOptions" label="Posición: " :has-feedback="false">
          <a-input
            v-decorator="['position', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
        </a-form-item>
      </a-col>

      <a-col v-bind="colOptions">
        <a-form-item v-bind="fiOptions" label="Etiqueta: " :has-feedback="false">
          <a-input
            v-decorator="['label', { rules: [{ required: true, message: 'Valor requerido'}] }]"/>
        </a-form-item>
      </a-col>
      <a-col v-bind="colOptions">
        <g-dropdown endpoint="role"
                    label="Rol: "
                    :formItemConfig="fiOptions"
                    :decorator="['role_name', { rules: [{ required: false }] }]"
        >
        </g-dropdown>
      </a-col>


    </template>
  </g-master>
</template>
<script>
  export default {
    props: ['id_g_report'],
    computed: {
      jbParentData() {
        return {
          id_g_report: this.id_g_report
        }
      }
    },
    data() {
      return {
        colOptions: {xs: 24, sm: 24},
        fiOptions: {
          'label-col': {span: 8},
          'wrapper-col': {span: 16},
          'has-feedback': true
        },
        GColMaster: {
          endpoint: 'greportcol',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Rol', dataIndex: 'role_name', sorter: true},
              {title: 'Columna', dataIndex: 'column', sorter: true},
              {title: 'Descripción', dataIndex: 'label', sorter: true},
              {title: 'Posicion', dataIndex: 'position', sorter: true},
            ]
          },
          modalFieldsSetup: [
            {name: 'role_name'},
            {name: 'column'},
            {name: 'label'},
            {name: 'position'},
          ]
        }
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Mantenimiento/Greport/GReportCol.vue